import React, { Suspense } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { PrivateLayout, PublicLayout, ShopKeeperLayout } from 'views/layouts'; // Import EmployeeLayout
import PrivateRoutes from 'routes/private';
import PublicRoutes from 'routes/public';
import { _Object } from 'utils/interfaces';
import 'primeflex/primeflex.css';
// import 'bootstrap/dist/css/bootstrap.min.css';
import { routes } from 'utils/routes';
import EmployeeLayout from 'views/layouts/employee';


const App = () => {
  const { isUserLoggedIn, loggedInUser } = useSelector((state: { [key: string]: _Object }) => state.session);

  const roleBasedRoutes = (route: _Object) => {
    const role = loggedInUser?.role;
    if (role === 'admin') {
      return true;
    }

    if (role === 'employee' || role === 'shopkeeper') {
      return ['/app/new-store', '/app/stores'].includes(route.path);
    }
    return false;
  };
console.log('loggedInUser?.role',loggedInUser?.role);

  const getLayout = () => {
    if (loggedInUser?.role) {
      switch (loggedInUser?.role) {
        case 'admin':
          return PrivateLayout;
        case 'employee':
          return EmployeeLayout;
        case 'shopkeeper':
          return ShopKeeperLayout;
        default:
          return PrivateLayout;
      }
    }
    else {
      return PublicLayout;
    }
  };

  const Layout = getLayout();

  return (
    <BrowserRouter>
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path="/app" element={isUserLoggedIn ? <Layout /> : <Navigate to={routes.login} />} >
            <Route index element={<Navigate to={routes.promocode} />} />
            {PrivateRoutes.map((route: _Object, i: number) => {
              const accessCheck = roleBasedRoutes(route);

              if (accessCheck === true) {
                return (
                  <Route
                    key={i}
                    path={route.path}
                    element={<route.component />}
                  />
                );
              } else if (route.path === '/app/promocodes' && loggedInUser?.role === 'employee') {
                return <Route key={i} path={route.path} element={<Navigate to="/app/new-store" />} />;
              } else if (route.path === '/app/promocodes' && loggedInUser?.role === 'shopkeeper') {
                return <Route key={i} path={route.path} element={<Navigate to="/app/new-store" />} />;
              }
            })}

            <Route path="/app/*" element={<Navigate to={routes.promocode} />} />
          </Route>

          <Route path="/" element={!isUserLoggedIn ? <PublicLayout /> : <Navigate to={routes.promocode} />}>
            <Route index element={<Navigate to={routes.login} />} />

            {PublicRoutes.map((route, i) => (
              <Route
                key={i}
                path={route.path}
                element={<route.component />}
              />
            ))}

            <Route path="/*" element={<Navigate to={routes.login} />} />
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};

export default App;
